import { CircularProgress } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
import { RenderInputParams } from '@material-ui/lab/Autocomplete';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import * as React from 'react';
import { fetchScopeFeatureData, DropDownData } from '../featureConfigurationLayout/FeatureLayoutConfigurationRepository';
import { IAutoCompleteItem } from '../typings/autoComplete';

interface SelectorProps {
    onSelection?: (selection: IAutoCompleteItem, name: string) => void;
    // tslint:disable-next-line: no-any
    items?: any;
    required?: boolean;
    label?: string;
    name: string;
    value: string;
    disabled?: boolean;
    className?: string;
    /** @default 'standard' */
    variant?: 'standard' | 'outlined' | 'filled';
    /** @default 'medium' */
    size?: 'small' | 'medium';
}

interface SelectorState {
    selectedCode: string;
    selectedLabel: string;
}

export class DashboardLayoutScopeSelector extends React.Component<SelectorProps, SelectorState> {
    // tslint:disable-next-line: no-any
    public scopeData: any;

    constructor(props: SelectorProps, state?: SelectorState) {
        super(props, state);

        let scopesList = fetchScopeFeatureData(this.props.value);
        this.scopeData = scopesList.map( (scope: DropDownData) => ({value: scope.value, label: scope.text }));
        
        this.handleChange = this.handleChange.bind(this);
        
        if (this.scopeData && this.props.value) {
            // tslint:disable-next-line: no-any
            const filteredItem = this.scopeData.find((item: any) => item.value.toLowerCase() === (this.props.value.toLowerCase()));

            this.state = {
                selectedCode:  filteredItem.value,
                selectedLabel: filteredItem.label
            };
        } else {
            this.state = {
                selectedCode:  '',
                selectedLabel: ''
            };
        }
    }

    public shouldComponentUpdate(nextProps: SelectorProps) {
        if (this.state.selectedCode !== nextProps.value) {
            return true;
        }

        return false;
    }

    public UNSAFE_componentWillReceiveProps(nextProps: SelectorProps) {
        if (this.props.value !== nextProps.value && this.scopeData) {
            // tslint:disable-next-line: no-any
            const filteredItem = this.scopeData.find((item: any) => item.value.toLowerCase() === (nextProps.value.toLowerCase()));

            if (filteredItem && nextProps.value.toString() !== '') {
                this.setState({
                    selectedCode: filteredItem.value,
                    selectedLabel: filteredItem.label
                });
            } else {
                this.setState({
                    selectedCode: '',
                    selectedLabel: ''
                });
            }           
        }
    }

    public render() {
        // this.scopeData = scopesList.map( (scope: DropDownData) => ({value: scope.value, label: scope.text }));
        
        return (
            <div className={'downshift-wrapper'}>
                <Autocomplete
                    loading={false}
                    disabled={this.props.disabled}
                    autoSelect={true}
                    value={{value: this.state.selectedCode, label: this.state.selectedLabel}}
                    onChange={this.handleChange}
                    options={this.scopeData}
                    className={this.props.className}
                    size={this.props.size || 'medium'}
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={option => option.label}                    
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={params => (
                        <TextField 
                            {...params} 
                            label={this.props.label} 
                            variant={this.props.variant || 'standard'}
                            size={this.props.size || 'medium'}
                            fullWidth={true} 
                            margin="none" 
                            required={this.props.required}
                            InputProps={this.getInputProps(params, false)}  
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        const matches = match(option.label, inputValue);
                        const parts = parse(option.label, matches);
                
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                />
            </div>
        );
    }

    private getInputProps(params: RenderInputParams, isLoading?: boolean) {
        return  ({   
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),     
         });
    }

    // tslint:disable-next-line: no-any
    private handleChange(event: object, item: any) {        
        this.setState( {
            selectedCode: item ? item.value : '',
            selectedLabel: item ? item.label : ''
        });

        if (this.props.onSelection) {
            this.props.onSelection({label: item ? item.label : '', value: item ? item.value : ''},
                                   this.props.name);
        }     
    }
}